import dom from '../../wrapper/DomWrapper';
import { getAnchorTargetObj, sendMessage } from './utils';

const TemplatePreview = () => {
  const header = dom.getElement('.main__header');
  const isFixedHeader = dom.hasClass(header, 'header_fixed');
  let scrollToIframe = false;

  dom.window.onbeforeunload = () => {
    sendMessage({
      type: 'clearHeight',
      height: null,
    });

    sendMessage({
      type: 'height',
      height: null,
      cycle: 'unload',
    });
  };

  dom.window.addEventListener('click', (e) => {
    const targetObj = getAnchorTargetObj(e.target);

    sendMessage({
      type: 'iframeAnchorClick',
      ...targetObj,
    });
  });

  window.addEventListener('scroll', () => {
    if (scrollToIframe) return;

    sendMessage({
      type: 'onScroll',
      scrollTop: dom.window.pageYOffset,
    });
  });

  dom.window.addEventListener('message', (message) => {
    const {
      data: { type, scrollTop },
    } = message;

    switch (type) {
      case 'scrolling':
        sendMessage(
          {
            type: 'height',
            height: dom.document.body.clientHeight,
            isFixedHeader,
          },
          message.origin,
        );
        break;
      case 'onScroll':
        if (!scrollToIframe) {
          scrollToIframe = true;
        } else {
          dom.window.scroll(0, scrollTop);
        }
        break;
      case 'stopScroll':
        scrollToIframe = false;
        break;
      default:
        break;
    }
  });
};

export default TemplatePreview;
